<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valOperator"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <el-button @click="func.showAddDataDialog" type="primary" class="btn-add">{{ $t('g.added') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table @row-click.self="func.showDetails" :data="formData.tableData" style="width: 100%">
        <el-table-column prop="Id" label="ID" width="60">
        </el-table-column>
        <el-table-column prop="Name" label="计费名称" width="140">
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="90">
          <template #default="scope">
            <el-tag :class="scope.row.Status == 1 ? 'tag-success' : 'tag-fail'">
              {{ scope.row.Status == 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="CodePath" :label="$t('g.operator_ownership')" :show-overflow-tooltip='true'>
        </el-table-column>
        <!-- <el-table-column prop="ProvinceAndCityText" label="省市区" width="180"> 
          </el-table-column> -->
        <el-table-column prop="FlagFall" label="起步价">
          <template #default="scope">
            {{ scope.row.FlagFall }} 元
          </template>
        </el-table-column>
        <el-table-column prop="FlagFallTime" label="起步价时长" width="100">
          <template #default="scope">
            {{ scope.row.FlagFallTime }} 分钟
          </template>
        </el-table-column>
        <el-table-column prop="Duration" label="后续时长间隔时间" width="140">
          <template #default="scope">
            {{ scope.row.Duration }} 分钟
          </template>
        </el-table-column>
        <el-table-column prop="DurationRate" label="后续时长间隔价格" width="140">
          <template #default="scope">
            {{ scope.row.DurationRate }} 元
          </template>
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="160" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.edit(scope.row)" class="btn-edit" type="primary">{{
              $t('g.edit')
            }}</el-button>
            <el-button @click="func.delete(scope.row.Id)" class="btn-delete" type="primary"
              style="margin-left: 10px;">{{ $t('g.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="formData.operateType == 1 ? $t('g.added') : $t('g.edit')" v-model="formData.dialogVisible"
      width="85%" style="padding: 20px 30px;" align-center>
      <el-form label-width="140px" :model="formData.curData" style="margin-top: 45px;">
        <div class="box_flex">
          <el-form-item label="计费名称" style="width: 50%;">
            <el-input v-model="formData.curData.Name"></el-input>
          </el-form-item>
          <el-form-item label="状态" style="width: 50%;">
            <el-select class="inp" v-model="formData.curData.Status">
              <el-option label="启用" :value="1">
              </el-option>
              <el-option label="停用" :value="0">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item label="押金" style="width: 50%;">
            <el-input v-model="formData.curData.Deposit">
              <template #append>元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="一天封顶价格" style="width: 50%;">
            <el-input v-model="formData.curData.MaxRate">
              <template #append>元</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item :label="$t('rights.agent')" v-if="formData.is_opt" style="width: 50%;">
            <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.AgentCode"
              :props="formData.props2" :options="render.cascade_options_direct" />
          </el-form-item>
          <el-form-item :label="$t('g.operator')" style="width: 50%;">
            <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.CodePath"
              :props="formData.props" :options="render.cascade_options_direct" />
          </el-form-item>
        </div>
        <div class="box_flex">
          <el-form-item label="起步价时长" style="width: 50%;">
            <el-input v-model="formData.curData.FlagFallTime">
              <template #append>分钟</template>
            </el-input>
          </el-form-item>
          <el-form-item label="起步价" style="width: 50%;">
            <el-input v-model="formData.curData.FlagFall">
              <template #append>元</template>
            </el-input>
          </el-form-item>

        </div>
        <div class="box_flex">
          <el-form-item label="后续时长间隔时间" style="width: 50%;">
            <el-input v-model="formData.curData.Duration">
              <template #append>分钟</template>
            </el-input>
          </el-form-item>
          <el-form-item label="后续时长间隔价格" style="width: 50%;">
            <el-input v-model="formData.curData.DurationRate">
              <template #append>元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="func.updateData()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDetailVisible" width="80%" style="padding: 20px 30px;"
      align-center>
      <el-descriptions border>
        <el-descriptions-item label="计费名称">{{
          formData.showData.Name
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <span v-if="formData.showData.Type == 1">启用</span>
          <span v-else>停用</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator')">{{
          formData.showData.CodePath
        }}</el-descriptions-item>
        <el-descriptions-item label="押金">{{
          formData.showData.Deposit
        }}元</el-descriptions-item>
        <el-descriptions-item label="一天封顶价格">{{
          formData.showData.MaxRate
        }}元</el-descriptions-item>
        <el-descriptions-item label="起步价时长">{{
          formData.showData.FlagFallTime
        }}分钟</el-descriptions-item>
        <el-descriptions-item label="起步价">{{
          formData.showData.FlagFall
        }}元</el-descriptions-item>
        <el-descriptions-item label="后续时长间隔时间">{{
          formData.showData.Duration
        }}分钟</el-descriptions-item>
        <el-descriptions-item label="后续时长间隔价格">{{
          formData.showData.DurationRate
        }}元</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{
          formData.showData.CreateAtStr
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { operators, updateOperators, shortcuts, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import city from '@/common/city.json'
import axios from "axios"
import { ElMessage, ElMessageBox } from 'element-plus'
import i18n from '@/data/i18n/index'
import { isOperator, isPath, isAdmin, user } from '@/data/token'
import cfg from '@/common/conf'
export default {
  name: 'ExpensesCombo',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      operators,
      parkingFee: [
        {
          label: t('siteManager.parking_fee'),
          value: 1
        },
        {
          label: t('siteManager.free_parking'),
          value: 2
        }, {
          label: t('siteManager.free_time'),
          value: 3
        },
        {
          label: t('siteManager.charging_free'),
          value: 4
        }
      ],
      chargingStation: [
        {
          label: t('siteManager.public_stations'),
          value: 1
        },
        {
          label: t('siteManager.commercial_stations'),
          value: 2
        }, {
          label: t('siteManager.residential_station'),
          value: 3
        },
        {
          label: t('siteManager.highway_station'),
          value: 4
        },
        {
          label: t('siteManager.smart_station'),
          value: 5
        }
      ],
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      showData: {},
      valTime: '',
      valStatus: 0,
      valType: 0,
      operateType: 1,
      dialogVisible: false,
      dialogDetailVisible: false,
      dialogDisplayVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 500,
      valOperator: 0,
      devType: [],
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
      props2: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Code",
        emitPath: false,
        checkStrictly: true
      },
      addres_props: {
        children: "children", expandTrigger: 'hover',
        label: "name",
        value: "name",
        emitPath: true,
        checkStrictly: true
      },
      IsStartWith: 1,
      is_opt: false,
      activeName: 'first',
      time_slot: [],
      timeInfo: [],
      form_type: 'add',
      fileList: [],
      uploadVisible: false,
      dialogImageUrl: '',
      dataImg: {
        Img0: '',
        Img1: '',
        Img2: ''
      },
      DevType: ''
    })
    onMounted(() => {
      func.loadData()
      if (localStorage.getItem('user_info')) {
        formData.user_info = JSON.parse(localStorage.getItem('user_info'))
        if (formData.user_info.RoleId == 14 || formData.user_info.RoleId == 25 || formData.user_info.RoleId == 18) {
          formData.is_opt = true
        }
      }
    })
    const func = {
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      async showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        console.log('showDetails', row)
        formData.showData = row;
        formData.dialogDetailVisible = true;
      },
      handlePictureCardPreview(uploadFile) {
        formData.dialogImageUrl.value = uploadFile.url
        formData.uploadVisible.value = true
      },
      edit(row, column, e) {
        formData.operateType = 2
        formData.curData = row
        formData.form_type = 'edit'
        formData.dialogVisible = true
      },
      async optCity() {
        //console.log(JSON.stringify(formData.curData.ProvinceAndCity) )
      },
      async delete(Id) {
        ElMessageBox.confirm(t('g.sure_delete'), {
          confirmButtonText: t('confirm'),
          cancelButtonText: t('cancel'),
        }).then(() => {
          try {
            axios.post('/admin/bikebillset/del', {
              Id
            }).then((res) => {
              if (res == '删除成功') {
                ElMessage({
                  type: 'success',
                  message: t('g.success')
                })
              } else {
                ElMessage({
                  type: 'error',
                  message: t("err_code.20005")
                })
              }
              func.loadData()
            })

          } catch (error) {
            ElMessage({
              type: 'error',
              message: t("err_code.20005")
            })
          }

        })
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      showAddDataDialog() {
        formData.operateType = 1
        formData.curData = {}
        formData.form_type = 'add'
        formData.dialogVisible = true
      },
      async updateData() {
        console.log("updateOrCreate Data", formData.curData)
        // let data = Object.values(formData.curData).some(value => value === null || value === undefined || value === '');
        // if (data&&formData.curData.DevType == 2) {
        //   ElMessage({
        //     type: 'error',
        //     message: '请填写完整'
        //   })
        //   return
        // }

        try {
          let params = Object.assign({}, formData.curData)
          params.Type = 0
          params.Deposit = params.Deposit * 100
          params.FlagFall = params.FlagFall * 100
          params.DurationRate = params.DurationRate * 100
          params.MaxRate = params.MaxRate * 100
          // params.ProvinceAndCity = JSON.stringify(formData.curData.ProvinceAndCity)
          if (formData.form_type == 'edit') {
            params.Id = formData.curData.Id
            await axios.post('/admin/bikebillset/edit', params)
          } else {
            await axios.post('/admin/bikebillset/add', params)
          }
        } catch (e) {

        }
        formData.dialogVisible = false
        func.loadData()
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page

          let params = {
            page,
          }
          if (formData.valOperator) {
            params.CodePath = formData.valOperator
          }
          let res = await axios.get(`/admin/bikebillset/get`, {
            params
          })

          console.log('列表信息', res)
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreatedAt)
            item.Deposit = item.Deposit / 100
            item.FlagFall = item.FlagFall / 100
            item.DurationRate = item.DurationRate / 100
            item.MaxRate = item.MaxRate / 100
            // item.UpdateAtStr = toDay(item.UpdateAt)
          })
          formData.tableData = res.List
          formData.PageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }

    return {
      func,
      render,
      isOperator,
      isAdmin,
      formData,
      isPath,
      city,
      uploadUrl: cfg.uploadUrl,
      token: user.token,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;


        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 33%;
    }

    .inp {
      width: 100%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 50rem;
  }
}

.box_flex {
  display: flex;
}

.tabs {
  margin-bottom: 30px;
}

:deep .el-tabs--card>.el-tabs__header {
  border-top: 0px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header {
  background-color: #fff !important;
}


.form-row {
  text-align: left;
  // padding: 0 60px;
  margin-top: 45px;

  .inp {
    width: 500px;
  }

  .inp_right {
    margin-right: 15px;
  }

  .label_box {
    display: flex;
    margin-bottom: 15px
  }

  .title_label {
    width: 100px;
    text-align: right;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .money_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .time_money {
    margin-top: 30px
  }
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep .avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep .avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

:deep .el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>